module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.length),
      expression: "length"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.length = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetPagination()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-3 col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "placeholder": _vm.trans('messages.search') + '...'
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.resetPagination()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('datatable', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', [_vm._l((_vm.paginated), function(project) {
    return _c('tr', {
      key: project.id
    }, [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [(_vm.permissions.includes('projects.edit')) ? _c('a', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "href": '/manage/project/edit/' + project.id
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    }), _vm._v(" " + _vm._s(_vm.trans('messages.edit')))]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "btn btn-danger btn-sm confirm-delete",
      attrs: {
        "href": '/manage/project/delete/' + project.id
      }
    }, [_c('i', {
      staticClass: "fa fa-trash-o"
    }), _vm._v(" " + _vm._s(_vm.trans('messages.delete')) + " ")])])])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.trans('messages.loading_data')))])]), _vm._v(" "), (_vm.pagination.total == 0 && _vm.loading == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "5",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.trans('messages.no_data')))])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "client": true,
      "filtered": _vm.filteredProjects
    },
    on: {
      "prev": function($event) {
        --_vm.pagination.currentPage
      },
      "next": function($event) {
        ++_vm.pagination.currentPage
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e72752e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Projects.vue
// module id = 104
// module chunks = 0